import * as Sentry from '@sentry/browser'
import LogRocket from 'logrocket'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import { useEffect, useState } from 'react'
import { LOG_ROCKET_APP_ID_CONSOLE } from 'shared/config/config'

import { getLoggedInUserIdentityWithCache } from '../api/identity'
import { isProductionEnv, privateFieldNames } from '../config/config'
import { getUserFullName } from '../helpers/utils'

const initLogRocket = async () => {
  const { user } = await getLoggedInUserIdentityWithCache()
  const team = user?.team

  const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup(privateFieldNames)

  LogRocket.init(LOG_ROCKET_APP_ID_CONSOLE, {
    network: {
      requestSanitizer: (request) => {
        // scrub request body on login page
        if (request.url.toLowerCase().includes('/auth/console')) {
          request.body = undefined
        }
        // Apply the fuzzy sanitizer
        // @ts-ignore
        return requestSanitizer(request)
      },
      // @ts-ignore
      responseSanitizer,
    },
  })

  // Add a LogRocket session recording URL to every Sentry exception report.
  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra('sessionURL', sessionURL)
    })
  })

  if (user.email) {
    LogRocket.identify(user.id, {
      name: getUserFullName(user) || '',
      email: user.email,
      bundle_name: team?.product_subscription?.bundle_name ?? '',
    })
  }
}

export function useLogRocket() {
  const [logRocketInitialized, setLogRocketInitialized] = useState(false)

  useEffect(() => {
    if (isProductionEnv() && !logRocketInitialized) {
      initLogRocket().then(() => {
        setLogRocketInitialized(true)
      })
    }
  }, [logRocketInitialized])
}
